import { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";
import { Tooltip } from "antd";

// Chi tiết KTV - Chi tiết đơn tư vấn
const ViewDetailOrderServiceTvv = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertCurrency(data) {
        return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
        }).format(data);
    };

    const columns = [
        {
            title: 'Ngày giao dịch',
            fixed : 'left',
            align: "center",
            width: 90,
            render: (data) => {
                return (
                    <>
                        <p className="text4">{data.transaction_code}</p>
                        <p className="text4">{data.transaction_at}</p>
                    </>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            align: "center",
            width: 90,
            render: (data) => {
                return (
                    <>
                        <p className="text2">{data.order_code}</p>
                        <p className="text2">{data.order_at}</p>
                    </>
                )
            },
        },
        {
            title: 'Tên khách hàng',
            align: "center",
            width: 90,
            render: (data) => {
                return (
                    <>
                        <p className="text4">{data.customer_mobile}</p>
                        <p className="text4">{data.customer_name}</p>
                    </>
                )
            },
        },
        {
            title: 'Tên dịch vụ',
            align: "center",
            width: 170,
            render: (data) => {
                return (
                    <>
                        <p className="text1">{data.product_name}</p>
                    </>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền khách hàng thanh toán cho đơn hàng đó.'> 
                Thực thu bán hàng <i className="fas fa-info-circle"></i>
            </Tooltip>,
            align: "center",
            width: 120,
            render: (data) => {
                return (
                    <p className="text2">{convertCurrency(data.price_net)}</p>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền được thưởng cho kỹ thuật viên khi tư vấn cho khách hàng dựa trên số tiền khách thanh toán cho đơn hàng đó.'>
                Hoa hồng tư vấn <i className="fas fa-info-circle"></i>
            </Tooltip>,
            align: "center",
            width: 120,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data.price_com)}</p>
                )
            },
        },
        {
            title: 'Loại giao dịch',
            dataIndex: 'transaction_status',
            align: "center",
            width: 120,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Cơ sở thanh toán',
            dataIndex: 'store_pay',
            align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
    ];

    const handelExportUser = () => {
        setShowLoading(true)
        var url = `api/mysql/export/detail-user?type=2&user_id=${props.userId}&user_name=${props.userName}&start=${props.startDate}&end=${props.endDate}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }
  
    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button>
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey={(record, index) => index}
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ViewDetailOrderServiceTvv